import { render } from "./DemoInteractionGate.vue?vue&type=template&id=2987c734&scoped=true"
import script from "./DemoInteractionGate.vue?vue&type=script&lang=js"
export * from "./DemoInteractionGate.vue?vue&type=script&lang=js"

import "./DemoInteractionGate.vue?vue&type=style&index=0&id=2987c734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2987c734"]])

export default __exports__